import { Environment, Network, RecordSource, Store } from 'relay-runtime';
import config from './../config/config';

const BASE_URL = `${config.baseURL}`;

const fetchQuery = async (operation: any, variables: any) => {
  const response = await fetch(`${BASE_URL}/graphql`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: operation.text,
      variables,
      // schema: await fetchSchema()
    }),
  });

  return await response.json();
};

const environment = new Environment({
  network: Network.create(fetchQuery),
  store: new Store(new RecordSource()),
});

export default environment;
